import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useProjectDetailsPermissions } from '../../../projectDetails.permissions';
import { IProjectDetailsImagesStore } from '../projectDetailsImages.store';
import { IImageFilterService } from '../services/imageFilters.service';

export const SelectAllButtonContainer = observer((): ReactElement => {
  const imageFilterService = useInjection(IImageFilterService.$);
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);
  const permissions = useProjectDetailsPermissions();

  const { t } = useTranslator();

  const changeSelectionMode = (): void => {
    imageFilterService.changeSelectionMode();
  };

  const { selectionMode } = imagesStore;

  if (!permissions.canUpdateImageSet().allowed && !permissions.canBatchAnswer().allowed) {
    return <></>;
  }

  return (
    <Button
      variant={selectionMode === 'Select' ? 'outlined' : 'solid'}
      onClick={changeSelectionMode}
    >
      {t(selectionMode)}
    </Button>
  );
});
